module.exports = __webpack_public_path__ + "img/product32_img07.36da6c5d.png";